export interface CostFxValues {
  exchangeRate: string;
  baseCurrencyAmount: string;
  exchangeRateSource: string;
  exchangeRateCapturedAt: string;
}

export const EMPTY_COST_FX: CostFxValues = {
  exchangeRate: '', baseCurrencyAmount: '', exchangeRateSource: '', exchangeRateCapturedAt: '',
};

function localDateTimeValue(date = new Date()): string {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
}

export function normalizedCurrency(value: string): string {
  return value.trim().toUpperCase();
}

export function isForeignCurrency(sourceCurrency: string, baseCurrencyCode: string): boolean {
  const source = normalizedCurrency(sourceCurrency);
  const base = normalizedCurrency(baseCurrencyCode);
  return /^[A-Z]{3}$/.test(source) && /^[A-Z]{3}$/.test(base) && source !== base;
}

export function validCostFx(value: CostFxValues): boolean {
  const rate = Number(value.exchangeRate);
  const baseAmount = Number(value.baseCurrencyAmount);
  return Boolean(
    value.exchangeRate.trim() && Number.isFinite(rate) && rate > 0
    && value.baseCurrencyAmount.trim() && Number.isFinite(baseAmount) && baseAmount >= 0
    && value.exchangeRateSource.trim()
    && value.exchangeRateCapturedAt && Number.isFinite(new Date(value.exchangeRateCapturedAt).getTime()),
  );
}

export function costFxPayload(value: CostFxValues) {
  return {
    exchangeRate: Number(value.exchangeRate),
    baseCurrencyAmount: Number(value.baseCurrencyAmount),
    exchangeRateSource: value.exchangeRateSource.trim(),
    exchangeRateCapturedAt: new Date(value.exchangeRateCapturedAt).toISOString(),
  };
}

export function updateCostFxRate(value: CostFxValues, exchangeRate: string, sourceAmount: number | null): CostFxValues {
  const rate = Number(exchangeRate);
  const converted = sourceAmount != null && Number.isFinite(rate) && rate > 0
    ? (sourceAmount * rate).toFixed(2)
    : value.baseCurrencyAmount;
  return { ...value, exchangeRate, baseCurrencyAmount: converted,
    exchangeRateCapturedAt: value.exchangeRateCapturedAt || localDateTimeValue() };
}

export function costFxValuesFromSnapshot(snapshot?: {
  exchangeRate?: number | string | null;
  baseCurrencyAmount?: number | string | null;
  rateSource?: string | null;
  rateCapturedAt?: string | null;
} | null): CostFxValues {
  let exchangeRateCapturedAt = '';
  if (snapshot?.rateCapturedAt) {
    const capturedAt = new Date(snapshot.rateCapturedAt);
    if (Number.isFinite(capturedAt.getTime())) exchangeRateCapturedAt = localDateTimeValue(capturedAt);
  }
  return {
    exchangeRate: snapshot?.exchangeRate == null ? '' : String(snapshot.exchangeRate),
    baseCurrencyAmount: snapshot?.baseCurrencyAmount == null ? '' : String(snapshot.baseCurrencyAmount),
    exchangeRateSource: snapshot?.rateSource || '',
    exchangeRateCapturedAt,
  };
}
